import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Panel from '../../../../UniformComponents/Panel'
import Button from '../../../../UniformComponents/Button'
import Accordion from './Accordion'
import CheckboxGroup from '../../../form/CheckboxGroup'
import InfoAccordion from '../../../InfoAccordion'
import HoverInfo from '../../../../UniformComponents/HoverInfo'

@observer
class ReportFilters extends PureComponent {
    constructor(props) {
        super(props)
        const { store } = props
        this.isMaxbi = store.survey.isMaxbi()
        this.state = {
            showAdminBox: false,
        }
    }

    componentWillUnmount() {
        const { reportStore } = this.props
        const { appStore } = reportStore

        appStore.showDebug = false
    }

    toggleAdminBox = () => {
        this.setState((prevState) => ({
            showAdminBox: !prevState.showAdminBox,
        }))
    }

    editAdvancedXTab = (xtabId) => {
        const { reportStore } = this.props
        const xtab = R.pathOr([], ['xTabs'], reportStore).find(({ id }) => id === xtabId)
        reportStore.currAdvancedXTab = xtab
        reportStore.showAdvancedXTab = true
    }

    changeSurveyStatuses = (obj) => {
        const { reportStore } = this.props
        const { selectedResponseStatuses, responseStatuses, reloadData } = reportStore
        selectedResponseStatuses.clear()
        obj.value.forEach((v) => {
            selectedResponseStatuses.set(
                v,
                responseStatuses.find(({ value }) => value === v),
            )
        })
        reloadData()
    }

    isServiceStatusMsgShowing = () => !!document.getElementById('ssm-header')

    renderBenchmarkingBtn = () => {
        if (this.isMaxbi) return null
        const { reportStore } = this.props
        const { showComparison, showBenchmarking } = reportStore

        if (process.env.USE_BENCHMARKING_MODAL) {
            return (
                <Button
                    label={i18n.t('benchmarkModal.buttonTitle')}
                    icon="fa-regular fa-retweet"
                    cssClass="regular tertiary"
                    onClick={() => {
                        if (!showBenchmarking) reportStore.trackBenchmarksComparisonsOpened()
                        reportStore.showBenchmarking = !showBenchmarking
                    }}
                />
            )
        }
        return (
            <Button
                label={i18n.t('report_comparison')}
                icon="fa-light fa-filter-list"
                cssClass="regular tertiary"
                onClick={() => { reportStore.showComparison = !showComparison }}
            />
        )
    }

    render() {
        const {
            reportStore, store,
        } = this.props
        const { survey } = store

        const filterRulesExist = Object.entries(reportStore.filters).some(([_, ruleGroup]) => (ruleGroup.hasRules()))
        if (this.isMaxbi) return null
        return (
            <Fragment>
                <Panel id="pane1" cssClass="filter options" style={this.isServiceStatusMsgShowing() ? { top: '108px' } : {}}>
                    <div className="heading-container padding">
                        <div className="heading-title">
                            <h3>{i18n.t('s_report_analysis')}</h3>
                        </div>
                    </div>

                    <div className="left-panel-button-container report-filter vert">
                        <Button
                            cssClass="primary regular"
                            onClick={reportStore.toggleShowExportModal}
                            label={i18n.t('report_export_options')}
                            icon="fal fa-folder-arrow-down"
                        />

                        {this.renderBenchmarkingBtn()}
                    </div>

                    {!this.isMaxbi && (
                        <Fragment>
                            <Accordion
                                label={i18n.t('report_filters')}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                        marginBottom: '25px',
                                    }}
                                >
                                    {reportStore.showQuickFilter
                                        ? (
                                            <InfoAccordion
                                                title={i18n.t('report.filter.quick.guide.title')}
                                                show={reportStore.showQuickFilterInfo}
                                                toggle={() => { reportStore.showQuickFilterInfo = !reportStore.showQuickFilterInfo }}
                                            >
                                                {i18n.t('report.filter.quick.guide.text')}
                                            </InfoAccordion>
                                        )
                                        : (
                                            <>
                                                <div className="statuses" style={{ position: 'relative' }}>
                                                    <CheckboxGroup
                                                        name="surveyStatus"
                                                        label={i18n.t('report_status_filter_label')}
                                                        options={reportStore.responseStatuses}
                                                        defaultChecked={Array.from(reportStore.selectedResponseStatuses).map(([key]) => key)}
                                                        onBlur={this.changeSurveyStatuses}
                                                        returnValueUnchanged
                                                    />
                                                </div>
                                                {Object.entries(reportStore.filters).map(([type, ruleGroup]) => (
                                                    !ruleGroup.hasRules()
                                                        ? null
                                                        : (
                                                            <div
                                                                style={{
                                                                    fontWeight: 600,
                                                                    padding: '8px',
                                                                    borderRadius: '5px',
                                                                    background: '#F7F8FA',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                }}
                                                                key={type}
                                                            >
                                                                {i18n.t(`report.filter.${type}`)}
                                                                <i
                                                                    className="fa-regular fa-circle-xmark"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        ruleGroup.discard()
                                                                        reportStore.saveFilter(type, ruleGroup.constructor.clone(ruleGroup))
                                                                    }}
                                                                />
                                                            </div>
                                                        )
                                                ))}
                                            </>
                                        )}
                                </div>
                                {!reportStore.showQuickFilter && process.env.USE_QUICK_FILTER && (
                                    <Button
                                        cssClass="primary regular"
                                        label={i18n.t('report.filter.quick.enable')}
                                        icon="fa-light fa-filter"
                                        onClick={reportStore.enableQuickFilters}
                                        style={{ justifyContent: 'center', width: '100%' }}
                                    />
                                )}
                                {reportStore.showQuickFilter && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            gap: 5,
                                            padding: '5px',
                                            position: 'relative',
                                            background: '#FFF',
                                            zIndex: 101,
                                        }}
                                    >
                                        <Button
                                            cssClass="primary regular"
                                            label={i18n.t('cancel')}
                                            onClick={reportStore.cancelQuickFilters}
                                            style={{ justifyContent: 'center', width: '100%', zIndex: 101 }}
                                        />
                                        <Button
                                            cssClass="secondary regular"
                                            label={i18n.t('report.filter.quick.apply')}
                                            onClick={reportStore.applyQuickFilter}
                                            style={{ justifyContent: 'center', width: '100%', zIndex: 101 }}
                                        />
                                    </div>
                                )}
                                <br />
                                {!reportStore.showQuickFilter && (
                                    <div style={{
                                        display: 'flex', flexDirection: 'column', gap: '16px', position: 'relative',
                                    }}
                                    >
                                        {filterRulesExist ? (
                                            <Button
                                                label={i18n.t('clearFilters')}
                                                onClick={() => reportStore.discardAllFilters()}
                                                cssClass="tertiary regular"
                                                icon="fa-regular fa-trash"
                                                style={{ justifyContent: 'center', width: '100%' }}
                                            />
                                        ) : null }
                                        {survey.metadata.isRapidSurvey
                                            ? (
                                                <HoverInfo
                                                    cssClass="hover-info button-hover-info"
                                                    desc={i18n.t('rapidSurvey.disabledFeatureTitle')}
                                                    linkText={i18n.t('rapidSurvey.disabledFeatureBody')}
                                                    href="mailto:support@explori.com"
                                                    dir="top"
                                                >
                                                    <Button
                                                        icon="far fa-lock-keyhole"
                                                        label={i18n.t('report_filters_add')}
                                                        cssClass="primary regular"
                                                        onClick={() => { reportStore.showFilters = true }}
                                                        style={{ justifyContent: 'center', width: '100%' }}
                                                        disabled
                                                    />
                                                </HoverInfo>
                                            ) : (
                                                <Button
                                                    cssClass="primary regular"
                                                    label={i18n.t('report_filters_add')}
                                                    icon="fa-light fa-circle-plus"
                                                    onClick={() => { reportStore.showFilters = true }}
                                                    style={{ justifyContent: 'center', width: '100%' }}
                                                />
                                            )}
                                    </div>
                                )}
                            </Accordion>
                        </Fragment>
                    )}

                    {!reportStore.showQuickFilter && (
                        <div style={{ padding: '20px', position: 'relative' }}>
                            {!this.isMaxbi && (
                                survey.metadata.isRapidSurvey
                                    ? (
                                        <HoverInfo
                                            cssClass="hover-info cross-tabs-button-hover-info"
                                            desc={i18n.t('rapidSurvey.disabledFeatureTitle')}
                                            linkText={i18n.t('rapidSurvey.disabledFeatureBody')}
                                            href="mailto:support@explori.com"
                                            dir="top"
                                        >
                                            <Button
                                                icon="far fa-lock-keyhole"
                                                label={i18n.t('crossTabs')}
                                                cssClass="secondary regular"
                                                onClick={() => this.editAdvancedXTab(0)}
                                                style={{
                                                    justifyContent: 'center', width: '100%', marginBottom: '16px',
                                                }}
                                                disabled
                                            />
                                        </HoverInfo>
                                    ) : (
                                        <Button
                                            cssClass="secondary regular"
                                            label={i18n.t('crossTabs')}
                                            icon="fa-light fa-circle-plus"
                                            onClick={() => this.editAdvancedXTab(0)}
                                            style={{ justifyContent: 'center', width: '100%', marginBottom: '16px' }}
                                        />
                                    )
                            )}
                        </div>
                    )}
                </Panel>

                <Fragment>
                    {reportStore.stillLoading && (
                        <div id="overlay">
                            <div className="download">
                                <div className="downloadHeader">
                                    <span>{i18n.t('report.dataLoading')}</span>
                                    <i className="fal fa-times" onClick={reportStore.toggleStillLoading} />
                                </div>
                                <div className="downloadBody" style={{ margin: '10px' }}>
                                    {i18n.t('report.dataLoadingLongText')}
                                </div>
                            </div>
                        </div>
                    )}
                    {!reportStore.stillLoading && null}
                </Fragment>
            </Fragment>
        )
    }
}

export default ReportFilters
